<!-----------------------------------------------------------------------------
  Copyright (c) 2016 - 2021.                                                  -
  Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)           -
  All Rights Reserved.                                                        -
                                                                              -
  The software and data contained herein are confidential and proprietary     -
  information of Yega Yazilim ("Confidential Information").                   -
                                                                              -
  Users of this software may not disclose such Confidential Information and   -
  shall use it only in accordance with the terms of the license agreement     -
  they entered into with Yega Yazilim.                                        -
                                                                              -
  Author:  Ahmet Dogramaci                                                    -
  Date:    2021-02-28                                                         -
  ----------------------------------------------------------------------------->

<template>
  <div>
    <b-button-toolbar class="justify-content-center my-3">
      <b-button-group class="mr-3">
        <b-button variant="danger" @click="updateProduct"> Add To Quote</b-button>
      </b-button-group>
      <b-button-group>
        <b-button variant="link" @click="goBack"> Cancel</b-button>
      </b-button-group>
    </b-button-toolbar>
  </div>
</template>

<script>

import QuoteProduct from "../../business-objects/quote-product";

export default {
  name: "reconfigure-dialog-buttons",
  props: {
    quoteProduct: {
      type: QuoteProduct,
      required: true
    },
    isBto:{
      type: Boolean,
      default: false
    }
  },
  methods: {
    updateProduct() {
      let toBeConfirmed = false;
      if(this.isBto && this.quoteProduct.name === 'TBD'){
        toBeConfirmed = true;
      }
      if(toBeConfirmed && !confirm('This sku does not have a p#. It may take up to 12 hours for a part# to be assigned. Do you want to proceed ?')){
        return;
      }
      this.$store
          .dispatch('QuoteProductsStore/update', {
            id: this.quoteProduct.id,
            cfg_template_version_id: this.quoteProduct.cfg_template_version_id,
            cfg_item_ids: this.quoteProduct.cfg_item_ids,
            attributes_string:this.quoteProduct.attributes_string,
            details_attributes_string: this.quoteProduct.detail_attributes_string
          })
          .then((savedItem) => {
            debugger;
            this.$router.push({name: 'quote_path'});
          })
          .catch((error) => {
            alert(error.response ? error.response.data : error);
          });
    },
    goBack(){
      this.$router.go(-1);
    }
  }
}
</script>

<style scoped>

</style>
